import { render, staticRenderFns } from "./AdminBrandWrite.vue?vue&type=template&id=617c06d2&"
import script from "./AdminBrandWrite.vue?vue&type=script&lang=js&"
export * from "./AdminBrandWrite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports